import { makeStyles, Text } from '@rneui/themed'
import { Shift } from '@nextforce/api'
import React from 'react'

interface Props {
  shift?: Shift
}

export function ShiftAttributesView({ shift }: Props) {
  const styles = useStyles()

  if (!shift?.attributes || shift.attributes.length === 0) {
    return null
  }

  const attribute = shift.attributes[0]

  if (attribute.name.length === 0) {
    return null
  }

  return (
    <Text>
      {attribute.icon}
      <Text style={styles.text}> {attribute.name}</Text>
    </Text>
  )
}

const useStyles = makeStyles(theme => ({
  text: {
    color: theme.colors?.primary,
  },
}))
